/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const scoreBreakdownItemDataSchema = z.object({
	questionId: z.string(),
	rawScore: z.number(),
	weight: z.number(),
	weightedScore: z.number(),
	maxScore: z.number(),
})

export type ScoreBreakdownItemDataSchema = z.infer<typeof scoreBreakdownItemDataSchema>
